export default "__VITE_PUBLIC_ASSET__db309968__"